import React from "react";

export default function Error(props) {
  const error = props.error;
  return (
    <div className="">
      <div className="flex justify-between md:flex-row sm:flex-col xs:flex-col ">
        <h4 className="text-2xl px-4 font-semibold mb-8">Unexpected Error</h4>
        <h4 className="text-xl px-4 font-semibold mb-8 ">
        </h4>
      </div>

      <div className="flex justify-between">
        <h4 className="text-md px-4 mb-4">{error.message}</h4>
      </div>

      <div className="flex justify-between">
        <h4 className="text-md px-4 mb-4">{error.line2}</h4>
      </div>

      <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Status
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {error.statusCode}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Transaction ID</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {error.token}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Card Charged</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {error.card}
            </dd>
          </div>
          <div className="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Payment Proccessed</dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {error.paymentProccessed}
            </dd>
          </div>
        </dl>
      </div>

    </div>
  );
}
